import * as React from 'react';
import useReduxState from 'src/hooks/useReduxState';
import { useState, useEffect } from 'react';
import System from 'src/helper/system';


const defaultFilterType = 'All'
const filterType = [{
    key: '', slug: 'All'
}, {
    key: 'G', slug: 'Non Constraint'
}, {
    key: 'R', slug: 'Constraint'
}]

const ForecastSearchBox = (props) => {
    const [search, setSearch] = useState('')
    const [forecastSearch, setForecastSearch] = useReduxState('', 'setForecastSearch')
    const [clickedSearch, setClickedSearch] = useReduxState(false, 'setClickedSearch')
    const [forecastSearchCpnStatus, setForecastSearchCpnStatus] = useReduxState('', 'setForecastSearchCpnStatus')
    const [selectedFilterType, setSelectedFilterType] = useState('')
    const [filteredType, setFilteredType] = useState([])

    const onSearch = () => {
        setForecastSearch('');
        setForecastSearch(search)
        setClickedSearch(true)
    }

    useEffect(() => {
        async function setHere() {
            await setFilteredTypeData(selectedFilterType)
        }
        setHere()
    }, [])

    useEffect(() => {
        if (forecastSearch !== undefined && forecastSearch.trim().length <= 0) {
            setSearch('')
        }
    }, [forecastSearch])
    /** Ticket # : 10787 - On search param clear reset data related fixes - 08 Feb ,2024 */
    useEffect(() => {
        if(search?.trim()?.length <= 0)
        {
            setForecastSearch('')
            setClickedSearch(false)
        }
    }, [search])

    useEffect(() => {
        async function setHere() {
            await onSelectFilter(forecastSearchCpnStatus)
        }
        setHere()
    }, [forecastSearchCpnStatus])

    const setFilteredTypeData = async (type) => {
        var newArray = filterType.filter(function (el) {
            return el.key !== type;
        });
        setFilteredType(newArray)
    }

    const onSelectFilter = async (v) => {
        setForecastSearchCpnStatus(v)
        setSelectedFilterType(v.key)
        await setFilteredTypeData(v.key)
        if (forecastSearch !== undefined && forecastSearch.trim().length <= 0) {
            setClickedSearch(false)
        }
    }

    return (
        <div className='col-xl-5'>
            <div className="form-group">

                <div className="mb-3 input-group bs5 flex-nowrap input-group-dropdown forecast-dropdown">
                    <div className="bs5 input-group-prepend">
                        <button type="button" className="bs5 btn btn-secondary dropdown-toggle" data-toggle="dropdown">
                            <span className='text-none text-black font-arial font-13'>{forecastSearchCpnStatus ? forecastSearchCpnStatus.slug : defaultFilterType}</span>
                        </button>
                        <div className="dropdown-menu mt-0 py-0">
                            {
                                filteredType && filteredType.length > 0 &&
                                filteredType.map((v, i) => (
                                    <li key={i}
                                        onClick={async () => await onSelectFilter(v)}
                                    ><a className="dropdown-item px-2 py-1 font-13" href={void (0)}>{v.slug}</a></li>
                                ))
                            }
                        </div>
                    </div>
                    <input type="text" className="form-control form-control-sm forecast-input"
                        placeholder="Enter Keyword(s) or Customer Part Number"
                        onChange={(e) => setSearch(e.target.value)} value={search}
                        onKeyPress={(e) => System.onEnterKeyPress(e) === true ? onSearch() : ''} />
                    <div className="bs5 input-group-append flex-nowrap rounded-1">
                        <a className="bs5 btn btn-secondary btn-search-icon"
                            onClick={() => onSearch()}><i className="fa fa-search text-black-stone"></i></a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ForecastSearchBox;